import { Box, Button, VStack, Text, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { CreateAccountModal } from "./CreateAccountModal";

export function AddAccountCta(): React.ReactElement {
  const createAccountDisclosure = useDisclosure();

  return (
    <Box p={2}>
      <Box
        w="full"
        borderWidth="1px"
        borderColor="blue.200"
        bg="blue.50"
        rounded="md"
        p={4}
      >
        <VStack align="flex-start" spacing={4}>
          <Box>
            <Text fontWeight="semibold">
              Need to manage tax for another account?
            </Text>
            <Text fontSize="sm" mt={1}>
              Create one for a partner, company, trust, SMSF, or client. Starts
              on the free plan.
            </Text>
          </Box>

          <Button
            colorScheme="primary"
            variant="solid"
            size="sm"
            flexShrink={0}
            onClick={createAccountDisclosure.onOpen}
          >
            Add account
          </Button>
          {createAccountDisclosure.isOpen && (
            <CreateAccountModal disclosure={createAccountDisclosure} />
          )}
        </VStack>
      </Box>
    </Box>
  );
}
